import { getAdditionalFeesOrderItems } from './getAdditionalFeesOrderItems';
import { checkIfItemHasDiscount } from './discounts.utils';
import { getNonDeliveryAdditionalFees } from './deliveryAdditionalFee.utils';
function lineItemToCashierLineItem(lineItem, discountsToAlignWith) {
  var _lineItem$productName, _lineItem$productName2, _lineItem$description, _lineItem$price, _lineItem$priceBefore;
  if (discountsToAlignWith === void 0) {
    discountsToAlignWith = [];
  }
  const name = ((_lineItem$productName = lineItem.productName) == null ? void 0 : _lineItem$productName.translated) ?? ((_lineItem$productName2 = lineItem.productName) == null ? void 0 : _lineItem$productName2.original) ?? '';
  const options = ((_lineItem$description = lineItem.descriptionLines) == null ? void 0 : _lineItem$description.reduce((acc, descriptionLine) => {
    var _descriptionLine$name, _descriptionLine$name2, _descriptionLine$plai, _descriptionLine$plai2, _descriptionLine$colo, _descriptionLine$colo2;
    acc = acc !== '' ? acc + ' |' : acc;
    return acc + ` ${((_descriptionLine$name = descriptionLine.name) == null ? void 0 : _descriptionLine$name.translated) ?? ((_descriptionLine$name2 = descriptionLine.name) == null ? void 0 : _descriptionLine$name2.original)}: ${((_descriptionLine$plai = descriptionLine.plainText) == null ? void 0 : _descriptionLine$plai.translated) ?? ((_descriptionLine$plai2 = descriptionLine.plainText) == null ? void 0 : _descriptionLine$plai2.original) ?? ((_descriptionLine$colo = descriptionLine.colorInfo) == null ? void 0 : _descriptionLine$colo.translated) ?? ((_descriptionLine$colo2 = descriptionLine.colorInfo) == null ? void 0 : _descriptionLine$colo2.original)}`;
  }, '')) ?? '';
  const amount = ((_lineItem$price = lineItem.price) == null ? void 0 : _lineItem$price.amount) ?? '0';
  const priceBeforeDiscounts = ((_lineItem$priceBefore = lineItem.priceBeforeDiscounts) == null ? void 0 : _lineItem$priceBefore.amount) ?? '0';
  const price = checkIfItemHasDiscount(lineItem, discountsToAlignWith) ? priceBeforeDiscounts : amount;
  return {
    id: lineItem.id,
    name: options ? `${name}${options}` : name,
    price,
    quantity: lineItem.quantity ?? 0
  };
}
export function getOrderItemsFromCheckout(checkout, discountsToAlignWith, shouldMergeExpressDeliveryRateWithHandlingFee) {
  var _checkout$lineItems;
  if (discountsToAlignWith === void 0) {
    discountsToAlignWith = [];
  }
  if (shouldMergeExpressDeliveryRateWithHandlingFee === void 0) {
    shouldMergeExpressDeliveryRateWithHandlingFee = true;
  }
  const orderItems = ((_checkout$lineItems = checkout.lineItems) == null ? void 0 : _checkout$lineItems.map(lineItem => lineItemToCashierLineItem(lineItem, discountsToAlignWith))) ?? [];
  const additionalFees = shouldMergeExpressDeliveryRateWithHandlingFee ? getNonDeliveryAdditionalFees(checkout.additionalFees ?? []) : checkout.additionalFees;
  const additionalFeesAsOrderItems = getAdditionalFeesOrderItems(additionalFees);
  return [...orderItems, ...additionalFeesAsOrderItems];
}
//# sourceMappingURL=getOrderItemsFromCheckout.js.map